export default __webpack_public_path__ + "static/media/analytics.a708521a.svg";